<script lang="ts">
	import { page } from '$app/state';
	import { onMount } from 'svelte';

	const {
		price,
		quantity,
	}: {
		price: number;
		quantity: number;
	} = $props();

	const clientId = page.data.store.third_parties?.paypal?.client_id;
	const currency = page.data.store.currency;
	const storeCountry = page.data.store.country;

	onMount(() => {
		if (clientId) {
			// https://developer.paypal.com/studio/checkout/pay-later/fr
			const script = document.createElement('script');
			script.src = `https://www.paypal.com/sdk/js?client-id=${clientId}&currency=${currency}&components=messages`;
			script.async = true;
			document.head.appendChild(script);
		}
	});
</script>

{#if clientId}
	<div
		class="pp-message h-8 md:h-6"
		data-pp-message
		data-pp-pageType="product-details"
		data-pp-buyercountry={storeCountry}
		data-pp-currency={currency}
		data-pp-amount={price * quantity}
	></div>
{/if}
